import {
  descrColumnDefinition,
  countryTaxTypeColumnDefinition,
  companyCodeColumnDefinition,
  amountColumnDefinition,
  percentageColumnDefinition,
} from '../columnDefinitions';

export const detailColumnsDef = [
  descrColumnDefinition,
  countryTaxTypeColumnDefinition,
  companyCodeColumnDefinition,
  amountColumnDefinition,
  percentageColumnDefinition,
];
